// Shared contracts for the v2 EHR appointment dialog. One visit per appointment.

// A bookable slot, minutes from midnight, on one day.
export type SlotOption = {
  day: string
  start: number
  end: number
}

export type DayResults = {
  day: string
  label: string
  options: SlotOption[]
  total: number
}

export type SearchCriteria = {
  providerId: number | null
  windowStart: string
  windowDays: 7 | 14 | 30
}

export const WINDOW_OPTIONS = [7, 14, 30] as const

// Minutes from midnight, site wall clock.
export type MinuteRange = {
  start: number
  end: number
}

// A booking read from /schedule/day, reduced to what the room filter needs.
export type RoomBooking = MinuteRange & {
  id: number
  roomCode: string
  statusCode: number | null
  patientFirstName: string | null
  patientLastName: string | null
  appointmentWith: string | null
}

// One day of the schedule: the rooms the doctor holds and every booking in them.
export type RoomDay = {
  date: string
  rooms: { code: string; hours: MinuteRange[] }[]
  bookings: RoomBooking[]
}
